import React, { useMemo } from 'react';
import { getFormattedDayName } from '../../utils';

type CalendarDaysOfWeekProps = {
  locale?: string;
};

export default function CalendarDaysOfWeek({
  locale = 'en-US',
}: CalendarDaysOfWeekProps): JSX.Element {
  const dates: Date[] = useMemo(
    () => [
      new Date(2021, 5, 13),
      new Date(2021, 5, 14),
      new Date(2021, 5, 15),
      new Date(2021, 5, 16),
      new Date(2021, 5, 17),
      new Date(2021, 5, 18),
      new Date(2021, 5, 19),
    ],
    [],
  );
  return (
    <thead>
      <tr>
        {dates.map((d, idx) => (
          <th
            key={`dayOfWeek_${idx}`}
            className='select-none text-center text-green text-sm font-semibold leading-10 h-10 p-0 box-border'
          >
            {getFormattedDayName(d, 'short', locale)}
          </th>
        ))}
      </tr>
    </thead>
  );
}
